import { AsyncSubject, Observable } from 'rxjs';
import httpService from './httpService';
import { Notification } from '../data/models/notification.model';
import type {
  TripLegPackageDetail,
  TripLegPackage,
  TripServiceConfiguration,
} from '../data/models/trip-leg.model';
import { TripLegPackageRejectReason } from '../data/models/trip-leg-package-reject-reason.model';

class TripLegInventoryService {
  private readonly apiBase;
  private readonly apiTripBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_TRIP_LEG_PACKAGE_API_URL.trim();
    this.apiTripBase = __environment__.REACT_APP_TRIP_API_URL.trim();
  }

  public getOfferedPackages(
    providerID: number,
  ): Observable<TripLegPackageDetail[]> {
    const url = `${this.apiBase}/getOfferedPackages?&transportationProviderID=${providerID}`;
    return httpService.getJSON(url);
  }

  public getServiceConfiguration(): Observable<TripServiceConfiguration> {
    const url = `${this.apiBase}/getServiceConfiguration`;
    return httpService.getJSON(url);
  }

  public getTripLegPackage(
    packageUUID: string,
  ): Observable<TripLegPackageDetail> {
    const url = `${this.apiBase}/getPackage?&packageUUID=${packageUUID}`;
    return httpService.getJSON(url);
  }

  public acceptTripPackage(
    packageUUID: string,
  ): Observable<TripLegPackageDetail> {
    const url = `${this.apiBase}/tripLegPackageAccepted`;
    return httpService.postJSON(url, { packageUUID });
  }

  public rejectTripPackage(
    packageUUID: string,
    tripLegPackageStatusReasonBC: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiBase}/rejectTripLegPackage`;
    return httpService.postJSON(url, {
      packageUUID,
      tripLegPackageStatusReasonBC,
    });
  }

  public getTier3TripLegPackage(
    packageUUID: string,
  ): Observable<TripLegPackageDetail> {
    const url = `${this.apiTripBase}/package?packageUUID=${packageUUID}`;
    return httpService.getJSON(url);
  }

  public acceptTier3TripPackage(
    packageUUID: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiTripBase}/accept-package`;
    return httpService.postJSON(url, { packageUUID });
  }

  public rejectTier3TripPackage(
    packageUUID: string,
    tripLegPackageStatusReasonBC: string,
  ): Observable<TripLegPackage> {
    const url = `${this.apiTripBase}/reject-package`;
    return httpService.postJSON(url, {
      packageUUID,
      tripLegPackageStatusReasonBC,
    });
  }
}

const tripLegInventoryService = new TripLegInventoryService();

export default tripLegInventoryService;
